export const journeyQueryKeys = {
    singleJourney: 'singleJourney',
    journeyTestCases: 'journeyTestCases',
}